export default "__VITE_ASSET__BYDFbRl4__"